import React, { useState } from "react";
import "./Settings.css";
import Header from "../header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { Tabs } from "antd";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";
import { decryptObject } from "../GlobalFunction";
const { TabPane } = Tabs;

const Settings = () => {
  const sessionData = decryptObject(sessionStorage.getItem("sessioninfo"));
  const [userData, setUserData] = useState({
    name: sessionData.username,
    designation: sessionData.designation,
  });

  return (
    <div className="main-box">
      <Sidebar activeId={4} />
      <main className="main-content">
        <div
          style={{ display: "flex", flexDirection: "column", height: "100vh" }}
        >
          <Header title="Settings" user={userData} />
          <div style={{ flex: 1, backgroundColor: "#FAFAFB" }}>
            <div className="tab-container">
              <Tabs
                defaultActiveKey="1"
                style={{ width: "100%", height: "100%" }}
              >
                <TabPane tab="Edit Profile" key="1">
                  <EditProfile setUserData={setUserData} />
                </TabPane>
                <TabPane tab="Security" key="2">
                  <ChangePassword />
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Settings;
